export class StatusOption {
  constructor(public readonly label: string, public readonly color: string, public readonly statuses: string[]) {
  }
}
